import styles from './Universe26BannerVisual.module.css'
import universe26VisualDesktop from './assets/universe_26-visual-septsession-desktop.webp'
import universe26VisualMobile from './assets/universe_26-visual-septsession-mobile.webp'
import universe26VisualTablet from './assets/universe_26-visual-septsession-tablet.webp'

export function Universe26BannerVisual() {
  return (
    <div className={styles.visualContainer}>
      <picture>
        <source media="(min-width: 1012px)" srcSet={universe26VisualDesktop} />
        <source media="(min-width: 544px)" srcSet={universe26VisualTablet} />
        <img src={universe26VisualMobile} className={styles.visualImage} alt="" width="394" height="84" />
      </picture>
    </div>
  )
}
